export const RP_MIN_CONTRACT_MONTHS = 12
export const RP_CANCELLATION_PENALTY_PERCENT = 50

export type OriginChannel = 'AGENCIA' | 'PLATAFORMA' | 'INDICADOR' | 'VENDA_DIRETA'

export type PartnerStandard = {
  ready: boolean
  mode: 'RECORRENTE' | 'DUAS_MENSALIDADES' | null
  title: string
  detail: string
  commercial: string
}

const PARTNER_STANDARD: Record<OriginChannel, PartnerStandard> = {
  AGENCIA: {
    ready: true,
    mode: 'RECORRENTE',
    title: 'Agência',
    detail: '10% a 20% recorrente, conforme cadastro/promoção, enquanto o cliente indicado estiver ativo.',
    commercial: 'Comercial Rocket: 100% da 1ª parcela.',
  },
  PLATAFORMA: {
    ready: true,
    mode: 'RECORRENTE',
    title: 'Plataforma',
    detail: '10% a 20% recorrente, conforme cadastro/promoção, enquanto o cliente indicado estiver ativo.',
    commercial: 'Comercial Rocket: 100% da 1ª parcela.',
  },
  INDICADOR: {
    ready: true,
    mode: 'DUAS_MENSALIDADES',
    title: 'Indicador',
    detail: '100% da 1ª parcela somente. Pode ganhar prêmios das promoções.',
    commercial: 'Comercial Rocket: 50% da 1ª parcela.',
  },
  VENDA_DIRETA: {
    ready: true,
    mode: null,
    title: 'Venda direta',
    detail: 'Sem parceiro externo. Nenhuma comissão de parceiro.',
    commercial: 'Comercial Rocket: 100% da 1ª parcela.',
  },
}

export function standardForPartnerTipo(tipo?: string | null): PartnerStandard {
  const value = (tipo ?? '').trim().toUpperCase()
  const channel = value === 'RP' ? 'INDICADOR' : value
  if (channel === 'AGENCIA' || channel === 'PLATAFORMA' || channel === 'INDICADOR') return PARTNER_STANDARD[channel]
  return {
    ready: false,
    mode: null,
    title: 'Tipo sem padrão',
    detail: 'Defina o parceiro como Agência, Plataforma ou Indicador antes de converter.',
    commercial: 'A comissão do comercial só entra quando o tipo estiver no padrão.',
  }
}

export function directSaleStandard() {
  return PARTNER_STANDARD.VENDA_DIRETA
}

export const COMMERCIAL_ROWS = [
  { origin: 'Agência', value: 'Comercial Rocket: 100% da 1ª parcela' },
  { origin: 'Plataforma', value: 'Comercial Rocket: 100% da 1ª parcela' },
  { origin: 'Indicador', value: 'Comercial Rocket: 50% da 1ª parcela' },
  { origin: 'Venda direta', value: 'Comercial Rocket: 100% da 1ª parcela' },
] as const

export const PARTNER_ROWS = [
  { origin: 'Agência', value: '10% a 20% recorrente conforme cadastro/promoção' },
  { origin: 'Plataforma', value: '10% a 20% recorrente conforme cadastro/promoção' },
  { origin: 'Indicador', value: '100% da 1ª parcela somente e prêmios das promoções' },
] as const

export const RP_CONTRACT_LOCK = `Contrato mínimo de ${RP_MIN_CONTRACT_MONTHS} meses e multa de ${RP_CANCELLATION_PENALTY_PERCENT}% no cancelamento. Obrigatório. Não se ajusta.`
